function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "27",
  height: "23",
  viewBox: "0 0 27 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.133 2.737A6 6 0 0017 10h2.555a9.949 9.949 0 01-.406 6.426 9.95 9.95 0 01-16.233 3.23 9.955 9.955 0 010-14.077 9.95 9.95 0 018.217-2.842zm1.953.435A4 4 0 0017 8h1.769a9.947 9.947 0 00-5.683-4.828zm-.231 5.668a1.254 1.254 0 10-.96 2.317 1.254 1.254 0 00.96-2.317zm-4.437.274a1.253 1.253 0 00-.883-.369H7.52a1.253 1.253 0 00.015 2.507 1.253 1.253 0 00.883-2.138zm-.369 8.103a4.977 4.977 0 006.883-4.6H4.978a4.972 4.972 0 003.071 4.6z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.375 0C14.959 0 13 1.79 13 4s1.959 4 4.375 4h5.25C25.041 8 27 6.21 27 4s-1.959-4-4.375-4h-5.25zM17 5a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2z",
  fill: "#fff"
})));